import mockData from '../../../features/widget-net-worth/fixtures/data.json';

export default function* generator() {
    yield mockData;
}
